<script lang="ts">
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { devices_settings } from 'src/stores/device-runtime/status';
	//Services
	import { localReq, postReq } from '../../../../services/http';
	import { format } from '../../../../services/i18n';
	//Stores
	//Helpers
	import { get_local_ip } from '../../../../helpers/interface_helpers';
	//Design system components
	import { Button, Input, Text, toast } from '@Shelly/shelly-design-system';
	export let device;

	const settings = readDeviceSettings(device.id);
	let value = settings.power_correction;
	let cache = value;
	let loading = false;
	let min = 0.85;
	let max = 1.15;
	const localIp = get_local_ip(device.id);

	const setConsCalc = async () => {
		if (cache !== value) {
			let res;
			loading = true;

			if (localIp) {
				res = await localReq(device, `${localIp}/settings/`, 'post', {
					power_correction: value,
				});
			} else {
				res = await postReq(`/device/${device.category}/settings/power_correction`, {
					power_correction: value,
					channel: device.channel,
					id: device.id,
				});
			}

			if (res.isok) {
				settings.power_correction = value;
				devices_settings.update_devices_settings(device.id, settings);
				toast.open({
					type: 'success',
					title:
						$format('consumption_correction_change_scc_toast', {
							values: { value },
						}) || `Consumption correction was changed to ${value}.`,
				});
				cache = value;
			} else {
				toast.open({ type: 'danger', title: $format('error_global') });
				value = cache;
			}
			loading = false;
		}
	};
</script>

<Text styleType="body-small" class="mb-s">
	{$format('set_consumption_correction', {
		values: { min, max },
		default: 'Set consumption correction ({min} - {max}):',
	})}
</Text>

<Input
	class="mb-s"
	size="m"
	bind:value
	type={'number'}
	{min}
	{max}
	step={0.01}
	on:enter={setConsCalc}
	id="input-jkubzuv"
	aria-label={$format('set_consumption_correction', {
		values: { min, max },
		default: 'Set consumption correction ({min} - {max}):',
	})}
/>

<Button class="mt-s" {loading} size="m" width="full" on:click={setConsCalc}
	>{$format('button_save')}</Button
>
